// extracted by mini-css-extract-plugin
module.exports = {"MobileApp__desktop-view":"mobile-app_MobileApp__desktop-view__mdL1n","MobileApp__mobile-view":"mobile-app_MobileApp__mobile-view__yH6Cy"};